var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeutralMoodRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 139,
    viewBox: "0 0 212 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M157.531 12.7993C170.501 23.8256 177.038 40.8452 178.554 57.8301C192.854 61.2433 212.003 76.9787 212.003 97.9437C212.003 125.272 183.645 138.08 172.757 138.046L39.9092 137.675C18.1574 137.618 1.76258 118.562 0.131198 97.8974C-1.39606 78.6679 10.6253 63.8466 24.9953 53.8616C23.1673 41.6089 29.068 31.7627 38.6712 26.2438C48.6215 20.5281 60.261 19.7066 70.6626 26.4404C81.9203 11.0985 97.5283 1.0325 117.012 0.0721802C130.422 -0.587316 146.296 3.24239 157.531 12.7993Z",
    fill: "#36A9B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeutralMoodRightIcon);
export default __webpack_public_path__ + "static/media/neutralMoodRightIcon.ca9947ea9f0ad501af3bf3a872993914.svg";
export { ForwardRef as ReactComponent };